export default "__VITE_ASSET__a4c705f4__"